import {
  Box,
  Button,
  Checkbox,
  Fieldset,
  Flex,
  Grid,
  MultiSelect,
  NumberInput,
  Select,
  Tabs,
  Text,
  TextInput,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { IconCalendarMonth, IconCheck, IconX } from "@tabler/icons-react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  repositoryPos,
  RequiedCompont,
} from "../../../../_base/_const/_constVar";
import { formatToVietnamTz } from "../../../../_base/extension/DateExtension";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../../_base/model/_base/SelectListItemBase";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  tblPromotion,
  tblPromotionCommand,
} from "../../../../model/TblPromotion";
import { getTblDmEmployeeSelect } from "../../../../service/getSelectApi";
import { validateCreatePromotion } from "../../../../validate/UserCreateModelValidator";
import PromotionConditionModalV2 from "./Components/PromotionConditionModalV2";
import CustomersV2 from "./Components/SetupPromotionPolicy/CustomersV2";
import Pay from "./Components/SetupPromotionPolicy/Pay";
import SuperMarket from "./Components/SetupPromotionPolicy/SuperMarket";
import TableItemGiftPromotion from "./Components/TableItemPromotion/TableItemGiftPromotion";
import TableItemPrimaryPromotion from "./Components/TableItemPromotion/TableItemPrimaryPromotion";
import SaleChannel from "./Components/SetupPromotionPolicy/SaleChannel";

const CreatePromotionPolicyMultiple = () => {
  const navigate = useNavigate();
  const [selectedPolicyType, setSelectedPolicyType] = useState<string>("0");
  const [userSelect, setUserSelect] = useState<SelectListItemBase[]>([]);
  const dataPaymentMethod = [
    { value: "all", label: "Tất cả" },
    {
      value: "offline",
      label: "Thanh toán khi nhận hàng",
    },
    {
      value: "online",
      label: "Thanh toán bằng chuyển khoản",
    },
    {
      value: "card",
      label: "Thanh toán bằng thẻ quốc tế Visa, Master",
    },
  ];

  const entity: tblPromotion = {
    tblPromotionCommand: {
      id: 0,
      code: null,
      type: "0",
      createDate: null,
      createBy: null,
      stopTriggerRule: null,
      note: null,
      approveDate: null,
      approveBy: null,
      approveStatus: null,
      approveNote: null,
      priority: null,
      checkRewardPoint: null,
      checkNomalPromote: null,
      checkMixPromote: null,
      listPaymentMethod: null,
      listSaleChanel: null,
      attribute1: null,
      attribute2: null,
      attribute3: null,
      attribute4: "1",
      attribute5: null,
      attribute6: null,
      attribute7: null,
      attribute8: null,
      attribute9: null,
      attribute10: null,
      attribute11: null,
      attribute12: null,
      attribute13: null,
      attribute14: null,
      attribute15: null,
      listCustGroup: [],
      lisItemPrimary: [],
      listBranch: "",
      ismultiple: false,
      listType: [],
    },

    tblPromotionItemPrimaryCommands: [],
    tblPromotionItemAddOnCommands: [],
    tblPromotionItemGiftCommands: [],
  };

  const form = useForm<tblPromotion>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {},
  });

  const formHeader = useForm<tblPromotionCommand>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity.tblPromotionCommand,
    },
    validate: validateCreatePromotion,
  });

  const checkAllItemsExist = (arrayCheck: string[]): boolean => {
    const allValuesFromA = dataPaymentMethod
      .filter((item) => item.value !== "all")
      .map((item) => item.value);

    return allValuesFromA.every((value) => arrayCheck.includes(value));
  };

  /*************  ✨ Codeium Command ⭐  *************/
  /**
   * Function to handle the creation of a new promotion
   * @param dataSubmit the data of the promotion to be created
   * @returns {Promise<void>}
   */
  /******  a9b69603-70ea-4a22-8b8f-098b68a55e08  *******/

  const handleCreatePromotion = async (dataSubmit: tblPromotion) => {
    try {
      if (
        !dataSubmit.tblPromotionCommand?.effDate ||
        !dataSubmit.tblPromotionCommand?.expDate
      ) {
        NotificationExtension.Warn("Vui lòng chọn khoảng thời gian hiệu lực !");
        return;
      }

      const data = "/api/v1/TblPromotion/create";
      const dataApi = await repositoryPos.post<MessageResponse<boolean>>(
        data,
        dataSubmit
      );
      if (dataApi?.httpStatusCode === 200)
        if (dataApi && dataApi.success) {
          NotificationExtension.Success("Thêm mới thành công");
          setTimeout(() => {
            navigate("/config-system/config-promotion-policy-multiple");
          }, 2000);
        } else
          NotificationExtension.Fails(dataApi?.message || "Thêm mới thất bại");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedPolicyType) {
      form.setFieldValue("tblPromotionCommand.type", selectedPolicyType);
    }
  }, [selectedPolicyType]);

  useEffect(() => {
    const fetchDataCreatePromotion = async () => {
      const dataApi = await repositoryPos.get<MessageResponse<tblPromotion>>(
        "/api/v1/TblPromotion/create?Prefix=KM"
      );
      if (dataApi && dataApi.success) {
        formHeader.setValues(dataApi.data.tblPromotionCommand);
        formHeader.resetDirty(dataApi.data.tblPromotionCommand);
        formHeader.initialize(dataApi.data.tblPromotionCommand);
        if (dataApi.data.tblPromotionCommand.effDate) {
          formHeader.setFieldValue(
            "effDate",
            new Date(dataApi.data.tblPromotionCommand.effDate)
          );
        }
        formHeader.setFieldValue("type", "5");
        formHeader.setFieldValue("attribute3", "1");
        formHeader.setFieldValue("listPaymentMethod", ["all"]);
        formHeader.setFieldValue("listSaleChanel", "all");
      } else {
        NotificationExtension.Fails("Bạn không có quyền thực hiện thao tác");
        navigate("/config-system/config-promotion-policy-multiple");
      }
    };

    fetchDataCreatePromotion();
    fetchUser();
  }, []);

  const fetchUser = async () => {
    const dataseApi = await getTblDmEmployeeSelect();
    setUserSelect(dataseApi);
  };

  const _styleGrid = { base: 6, md: 3, lg: 2 };

  return (
    <Box
      component="form"
      onSubmit={formHeader.onSubmit(async (e) => {
        if (formHeader.validate().hasErrors) {
          NotificationExtension.Fails("Vui lòng điền đầy đủ thông tin !");
          return;
        }

        const listBranchValue = formHeader.getValues().listBranch;
        // if (!listBranchValue || listBranchValue.length < 1) {
        //   NotificationExtension.Fails("Vui lòng chọn chi nhánh áp dụng !");
        //   return;
        // }

        let _data = form.getValues();

        // if (
        //   !_data ||
        //   !_data.tblPromotionItemPrimaryCommands ||
        //   _data.tblPromotionItemPrimaryCommands.length < 1
        // ) {
        //   NotificationExtension.Fails("Vui lòng chọn mặt hàng áp dụng !");
        //   return;
        // }

        _data.tblPromotionCommand = formHeader.getValues();
        _data.tblPromotionCommand.effDate = formatToVietnamTz(
          _data.tblPromotionCommand.effDate
        );
        _data.tblPromotionCommand.attribute6 =
          _data.tblPromotionCommand.type !== "4"
            ? "false"
            : _data.tblPromotionCommand.attribute6;
        _data.tblPromotionCommand.expDate = formatToVietnamTz(
          _data.tblPromotionCommand.expDate
        );
        _data.tblPromotionCommand.countDownDate = _data.tblPromotionCommand
          .countDownDate
          ? formatToVietnamTz(_data.tblPromotionCommand.countDownDate)
          : null;
        _data.tblPromotionCommand.listPaymentMethod = Array.isArray(
          _data.tblPromotionCommand.listPaymentMethod
        )
          ? _data.tblPromotionCommand.listPaymentMethod.join(",")
          : _data.tblPromotionCommand.listPaymentMethod;
        await handleCreatePromotion(_data);
      })}
    >
      <Flex
        align={"center"}
        gap={"md"}
        justify={"space-between"}
        px={"3px"}
        wrap={"wrap"}
      >
        <Text size={"16px"} tt={"uppercase"} fw={"bold"}>
          Thêm mới chính sách khuyến mãi đa điều kiện
        </Text>
        <Flex gap={"md"}>
          <Button
            type="submit"
            variant="outline"
            color="teal"
            leftSection={<IconCheck size={14} />}
          >
            Lưu chính sách
          </Button>
          <Button
            variant="outline"
            color="red"
            leftSection={<IconX size={14} />}
            onClick={() => navigate(-1)}
          >
            Đóng
          </Button>
        </Flex>
      </Flex>
      <Grid>
        <Grid.Col span={12} h={"max-content"}>
          <Box h={"max-content"}>
            <Fieldset
              legend="Thông tin chung"
              // display={"flex"}
              // style={{ flexDirection: "column", gap: "10px" }}
            >
              <Grid>
                <Grid.Col span={_styleGrid}>
                  <TextInput
                    label="Mã CTKM"
                    placeholder="Nhập Mã CTKM"
                    readOnly
                    withAsterisk
                    key={formHeader.key("code")}
                    {...formHeader.getInputProps("code")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <Select
                    key={formHeader.key("createBy")}
                    label="Người lập"
                    placeholder="Vui lòng chọn..."
                    nothingFoundMessage="Không có dữ liệu"
                    readOnly
                    limit={1}
                    data={userSelect.map((doctype) => ({
                      value: doctype.value,
                      label: doctype.text,
                    }))}
                    searchable
                    withAsterisk
                    {...formHeader.getInputProps("createBy")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <Select
                    key={formHeader.key("type")}
                    label="Chính sách khuyến mại"
                    placeholder="Vui lòng chọn..."
                    nothingFoundMessage="Không có dữ liệu"
                    data={[
                      { label: "CTKM đa điều kiện", value: "5" },
                      { label: "Combo", value: "3" },
                    ]}
                    searchable
                    withAsterisk
                    {...formHeader.getInputProps("type")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <DateTimePicker
                    label="Thời gian bắt đầu đếm ngược"
                    placeholder="Thời gian bắt đầu đếm ngược"
                    minDate={new Date()}
                    locale="vi"
                    rightSection={<IconCalendarMonth size={14} />}
                    clearable
                    key={formHeader.key("countDownDate")}
                    {...formHeader.getInputProps("countDownDate")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <DateTimePicker
                    key={formHeader.key("effDate")}
                    label="Hiệu lực từ ngày"
                    placeholder="Hiệu lực từ ngày"
                    minDate={new Date()}
                    locale="vi"
                    rightSection={<IconCalendarMonth size={14} />}
                    withAsterisk
                    clearable
                    {...formHeader.getInputProps("effDate")}
                  />
                </Grid.Col>

                <Grid.Col span={_styleGrid}>
                  <DateTimePicker
                    label="Đến ngày"
                    placeholder="Đến ngày"
                    locale="vi"
                    withAsterisk
                    clearable
                    minDate={
                      formHeader.getValues().effDate
                        ? new Date(
                            dayjs(formHeader.getValues().effDate)
                              .add(0, "day")
                              .toDate()
                          )
                        : new Date()
                    }
                    rightSection={<IconCalendarMonth size={14} />}
                    key={formHeader.key("expDate")}
                    {...formHeader.getInputProps("expDate")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                  <MultiSelect
                    label="Chọn phương thức thanh toán"
                    placeholder="Vui lòng chọn phương thức thanh toán"
                    nothingFoundMessage="Không có dữ liệu"
                    data={dataPaymentMethod}
                    value={
                      formHeader.getValues()?.listPaymentMethod &&
                      Array.isArray(formHeader.getValues()?.listPaymentMethod)
                        ? formHeader.getValues()?.listPaymentMethod
                        : []
                    }
                    searchable
                    {...formHeader.getInputProps("listPaymentMethod")}
                    onChange={(e) => {
                      if (
                        (e?.includes("all") &&
                          e.indexOf("all") === e.length - 1) ||
                        checkAllItemsExist(e)
                      ) {
                        formHeader.setValues((prev) => ({
                          ...prev,
                          listPaymentMethod: ["all"],
                        }));
                      } else if (
                        e?.includes("all") &&
                        e.indexOf("all") === 0 &&
                        e.length > 1
                      ) {
                        formHeader.setValues((prev) => ({
                          ...prev,
                          listPaymentMethod: e
                            ? e.filter((item) => item !== "all")
                            : [],
                        }));
                      } else {
                        formHeader.setValues((prev) => ({
                          ...prev,
                          listPaymentMethod: e ? e : [],
                        }));
                      }
                    }}
                    withAsterisk
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                  <Select
                    key={formHeader.key("attribute3")}
                    label="Áp dụng"
                    placeholder="Chọn trình duyệt áp dụng"
                    data={[
                      { label: "Áp dụng đồng thời POS và Web", value: "1" },
                      { label: "Chỉ áp dụng trên POS", value: "2" },
                      { label: "Chỉ áp dụng trên Web", value: "3" },
                    ]}
                    withAsterisk
                    {...formHeader.getInputProps("attribute3")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4 }}>
                  <TextInput
                    label="Tên CTKM"
                    placeholder="Tên CTKM"
                    withAsterisk
                    key={formHeader.key("note")}
                    {...formHeader.getInputProps("note")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4 }}>
                  <TextInput
                    label="Ghi chú"
                    placeholder="Nhập ghi chú"
                    key={formHeader.key("attribute5")}
                    {...formHeader.getInputProps("attribute5")}
                  />
                </Grid.Col>
              </Grid>
              <Grid mt={5}>
                <Grid.Col span={12}>
                  <Flex justify={"start"} align={"center"} gap={"md"}>
                    <Checkbox
                      key={formHeader.key("ismultiple")}
                      label="Áp dụng đồng thời CTKM khác"
                      {...formHeader.getInputProps("ismultiple", {
                        type: "checkbox",
                      })}
                    />
                    {formHeader.getValues()?.type === "4" && (
                      <Checkbox
                        label="Mỗi số điện thoại chỉ được áp dụng 1 lần"
                        checked={formHeader.getValues()?.attribute6 === "true"}
                        onClick={() =>
                          formHeader.setValues((prev) => ({
                            ...prev,
                            attribute6:
                              formHeader.getValues()?.attribute6 &&
                              formHeader.getValues()?.attribute6 === "true"
                                ? "false"
                                : "true",
                          }))
                        }
                      />
                    )}
                  </Flex>
                </Grid.Col>
              </Grid>
            </Fieldset>
          </Box>
        </Grid.Col>

        <Grid.Col span={12}>
          {/* Tabs luôn được render, chỉ ẩn/hiện bằng CSS */}
          <Tabs
            defaultValue={"primary"}
            styles={{
              tabLabel: { fontWeight: 700, fontSize: 13 },
              panel: {
                overflowX: "visible",
              },
            }}
          >
            <Tabs.List>
              {/* <Tabs.Tab value="otherConditions">Điều kiện khác</Tabs.Tab> */}
              <Tabs.Tab value="primary">Mặt hàng chính</Tabs.Tab>
              {formHeader.getValues()?.type === "1" ? (
                <>
                  <Tabs.Tab value="gift">Mặt hàng tặng</Tabs.Tab>
                </>
              ) : (
                <></>
              )}
              <Tabs.Tab value="quantity">Số lượng</Tabs.Tab>
              <Tabs.Tab value="price">Tổng tiền</Tabs.Tab>
              <Tabs.Tab value="category">Mua cùng danh mục sản phẩm</Tabs.Tab>
              <Tabs.Tab value="bundle">Sản phẩm mua kèm</Tabs.Tab>
              <Tabs.Tab value="type">Mua cùng loại sản phẩm</Tabs.Tab>
              <Tabs.Tab value="brand">Mua cùng chủng sản phẩm</Tabs.Tab>
              <Tabs.Tab value="group">Mua cùng nhóm sản phẩm</Tabs.Tab>
              <Tabs.Tab value="BCPApprove">
                Chi nhánh, khách hàng và kênh bán áp dụng
              </Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="primary">
              <TableItemPrimaryPromotion
                form={form}
                typePromotion={formHeader.getValues()?.type ?? ""}
              />
            </Tabs.Panel>
            <Tabs.Panel value="gift">
              <TableItemGiftPromotion form={form} />
            </Tabs.Panel>
            <Tabs.Panel value="quantity">
              {/* <PromotionQuantity /> */}
              <PromotionConditionModalV2
                initialData={"quantity"}
                form={formHeader}
              />
            </Tabs.Panel>
            <Tabs.Panel value="price">
              {/* <PromotionPrice /> */}
              <PromotionConditionModalV2
                initialData={"price"}
                form={formHeader}
              />
            </Tabs.Panel>
            <Tabs.Panel value="category">
              {/* <PromotionCategoryItem /> */}
              <PromotionConditionModalV2
                initialData={"category"}
                form={formHeader}
              />
            </Tabs.Panel>
            <Tabs.Panel value="bundle">
              {/* <PromotionProduct /> */}
              <PromotionConditionModalV2
                initialData={"bundle"}
                form={formHeader}
              />
            </Tabs.Panel>
            <Tabs.Panel value="type">
              {/* <PromotionType /> */}
              <PromotionConditionModalV2
                initialData={"type"}
                form={formHeader}
              />
            </Tabs.Panel>
            <Tabs.Panel value="brand">
              <PromotionConditionModalV2
                initialData={"brand"}
                form={formHeader}
              />
            </Tabs.Panel>
            <Tabs.Panel value="group">
              {/* <PromotionGroup /> */}
              <PromotionConditionModalV2
                initialData={"group"}
                form={formHeader}
              />
            </Tabs.Panel>

            <Tabs.Panel value="BCPApprove">
              <Grid>
                <Grid.Col span={{ base: 12, md: 12, lg: 4 }}>
                  <Fieldset legend="Chi nhánh" mt={10}>
                    <SuperMarket form={formHeader} />
                  </Fieldset>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 4 }}>
                  <Fieldset legend="Đối tượng khách hàng" mt={10}>
                    <CustomersV2 form={formHeader} />
                  </Fieldset>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Fieldset legend={"Kênh bán áp dụng"} mt={10}>
                    <SaleChannel form={formHeader} />
                  </Fieldset>
                </Grid.Col>
              </Grid>
            </Tabs.Panel>
          </Tabs>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default CreatePromotionPolicyMultiple;
